<template >

  <div id="loginbg">  ·

    <div id="yufu-image">
    </div>
    <div id="biaoti" ></div>
    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
      <el-form-item prop="account">
        <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="电话"></el-input>
      </el-form-item>
      <el-form-item prop="checkPass">
        <el-input  type="text" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="验证码">
        </el-input>
        <el-button id="code" type="primary" size="mini" style="left: 244px;position: absolute;top: 6.5px;width: 100px;" @click="sendCode" :disabled="codeDisabled">
          {{codeMsg}}
        </el-button>
      </el-form-item>
      <!--<el-checkbox v-model="checked" checked class="remember">记住密码</el-checkbox>-->
      <el-link style="left: 290px;top: -10px"  href="https://ahyfyx.com/#/cardLogin">卡号登录</el-link>
      <!--<el-link style="left: 210px;top: -3px"  href="http://localhost:8882/#/cardLogin">卡号登录</el-link>-->
      <el-form-item style="width:100%;top:10px">
        <el-button type="primary"  style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
      </el-form-item>
    </el-form>
    <div id="all" ></div>
    <el-link id="beian" href="https://beian.miit.gov.cn/" target=‘_blank’  >
      <div>
        蜀ICP备18021345号-2
      </div>
    </el-link>
  </div>
</template>

<script>
  import { requestLogin } from '../../api/api';
  //import NProgress from 'nprogress'
  export default {
    data() {
      return {
        // 是否禁用按钮
        codeDisabled: false,
        // 倒计时秒数
        countdown: 60,
        // 按钮上的文字
        codeMsg: '获取验证码',
        // 定时器
        timer: null,
        logining: false,
        ruleForm2: {
          account: '',
          checkPass: ''
        },
        rules2: {
          account: [
            { required: true, message: '请输入电话', trigger: 'blur' },
            { pattern: /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/, message: '请输入正确的号码格式', trigger: 'change' }
            //{ validator: validaePass }
          ],
          checkPass: [
            { required: true, message: '请输入验证码', trigger: 'blur' },
            //{ validator: validaePass2 }
          ],
          fits: ['fill', 'contain', 'cover', 'none', 'scale-down'],
          url: '../../assets/LOGO-800.png'
        },
        checked: false
      };
    },
    methods: {
      handleSubmit2(ev) {
        var _this = this;
        this.$refs.ruleForm2.validate((valid) => {
          if (valid) {
            //_this.$router.replace('/table');
            this.logining = true;
            //NProgress.start();
            var loginParams = {
              phone: this.ruleForm2.account,
              code: this.ruleForm2.checkPass ,
            };
            //发起请求 http://localhost:1020/hrm/  auth/auth/oauth/token?
            this.$http.post("/login/account",loginParams).then(res=>{
              //获取到Token
              if(res.data.success){
                let {token,loginInfo,permissions} = res.data.data;
                //把token存储起来
                localStorage.setItem("U-TOKEN",token);
                localStorage.setItem("loginInfo",JSON.stringify(loginInfo));
                //localStorage.setItem("R-TOKEN",refresh_token);
                localStorage.setItem("permissions",JSON.stringify(permissions));
                if (res.data.data.loginInfo.role == 1){
                  var phone1 = this.ruleForm2.account
                  this.$router.push({ path: '/userReservationOrder',query: {phone:phone1} });
                }else if (res.data.data.loginInfo.role == 2  ){
                  this.$router.push({ path: '/serviceReservationOrder' });
                }else if (res.data.data.loginInfo.role == 3){
                  this.$router.push({ path: '/deliverReservationOrder' });
                }
                //修改登录成功后跳转到首页
                this.logining = false;
              }else{
                this.$message.warning(res.data.message);
                this.logining = false;
                return;
              }
            }).catch(error => {
              this.$message.error("登录失败["+error.message+"]");
              this.logining = false;
              return;
            });

          } else {
            //console.log('error submit!!');
            return false;
          }
        });
      },
      sendCode(){
        //1.判断手机号不为空
        if(!this.ruleForm2.account){
          this.$message({
            message: "手机号不能为空",
            type: 'error'
          });
          return;
        }
        var loginPhone = {
          phone: this.ruleForm2.account
        };
        this.$http.post("/code/send",loginPhone).then(result =>{
          //console.log(result)
          if (result.data.success) {
            this.$message.success("手机验证码已经发送到您的手机，请在3分钟内使用");
            // 验证码60秒倒计时
            if (!this.timer) {
              this.getValidStr();
              this.timer = setInterval(this.getValidStr, 1000)
            }
          }else {
            this.$message.error(result.data.message);
          }
        }).catch(result =>{
          this.$message.error(result.data.message);
        })
      },
      getValidStr(){
        if (this.countdown > 0 && this.countdown <= 60) {
          this.countdown--;
          if (this.countdown !== 0) {
            this.codeMsg = "重新发送" + this.countdown + "S";
            this.codeDisabled = true;
          } else {
            clearInterval(this.timer);
            this.codeMsg = "获取验证码";
            this.countdown = 60;
            this.timer = null;
            this.codeDisabled = false;
          }
        }
      },
    }
  }

</script>

<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 75px auto;
    width: 350px;
    padding: 60px 50px 35px 45px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }
    .remember {
      margin: 0px 0px 20px 0px;
    }
  }
  #loginbg{
    background-image: url('../../assets/login.png');
    background-position: center;
    background-size:  100% 100%;
    background-repeat: no-repeat;
    height: 940px;
    //background-color: black;
  }
  #yufu-image{
    background-image: url('../../assets/yufu.png');
    background-position: center;
    //background-size:  80% 80%;
    background-repeat: no-repeat;
    height: 100px;
    margin-top:80px;
    //background-color: black;
  }
  #biaoti{
    background-position: center;
    //background-size:  10% 10%;
    background-repeat: no-repeat;
    //background-color: black;
  }
  #all{
    background-image: url('../../assets/all.png');
    background-position: center;
    background-repeat: no-repeat;
    height: 50px;
  }
  #beian{
    //display: block;
    left: 890px;
    text-align: center;
    margin-top: 140px;
  }
</style>



// WEBPACK FOOTER //
// Login.vue?6c6dca9f